import { Injectable } from '@angular/core';
import { ApiService, UtilService, AuthService } from '..';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private _utilService: UtilService, private _apiService: ApiService, private _authService: AuthService) {}

  public downloadFile(url: string, saveAsFileName: string): Promise<void> {
    return this._apiService.getFile(url).then((resp: Blob) => {
      saveAs(resp, saveAsFileName);
    });
  }

  public uploadFile(url: string, formData: FormData): Promise<void> {
    return this._apiService.postFile(url, formData);
  }

  public getPublicFileDownloadUrl(downloadRoute: string, saveAsFileName: string): string {
    return `${this._authService.getTenantHttpsUrl()}/spa/files/download?downloadRoute=${downloadRoute}&saveAsFileName=${saveAsFileName}`;
  }
}
